import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import useStore from './store'
import Login from './pages/Login'
import AppLayout from './pages/Layout'
import Dashboard from './pages/Dashboard'
import Projects from './pages/Projects'
import Accounts from './pages/Accounts'
import Income from './pages/Income'
import Expenses from './pages/Expenses'
import Reports from './pages/Reports'
import Categories from './pages/Categories'
import ExchangeRates from './pages/ExchangeRates'
import Users from './pages/Users'
import Owners from './pages/Owners'

dayjs.locale('zh-cn')

function PrivateRoute({ children }) {
  const { token } = useStore()
  return token ? children : <Navigate to="/login" replace />
}

function AdminRoute({ children }) {
  const { user } = useStore()
  return user?.role === 'admin' ? children : <Navigate to="/" replace />
}

export default function App() {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 8,
          fontFamily: "'Inter', -apple-system, 'PingFang SC', 'Microsoft YaHei', sans-serif",
          colorBgContainer: '#ffffff',
          boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        },
        components: {
          Table: { borderRadius: 10 },
          Card: { borderRadius: 12 },
          Button: { borderRadius: 8 },
          Input: { borderRadius: 8 },
          Select: { borderRadius: 8 },
        }
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><AppLayout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="projects" element={<Projects />} />
            <Route path="accounts" element={<Accounts />} />
            <Route path="income" element={<Income />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="reports" element={<Reports />} />
            <Route path="categories" element={<Categories />} />
            <Route path="exchange-rates" element={<ExchangeRates />} />
            <Route path="owners" element={<Owners />} />
            <Route path="users" element={<AdminRoute><Users /></AdminRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  )
}
